<template>
  <div ref="container_app_responsive_embed" class="characters_uberfiles_app">
    <div ref="bg-interactive-wrapper" class="fake-bg-sticky">
      <img src="@/assets/bg-test.jpg" />
    </div>
    <div ref="bg-interactive-wrapper-2" class="fake-bg-sticky">
      <img src="@/assets/layer2embed.png" />
    </div>
    <BContainer fluid ref="real_estate_wrapper" class="real_estate_wrapper" v-if="case_item && case_item.index">
      <BRow class="no-gutters justify-content-center"> 

        <BCol cols="12" role="tablist">
          <div :class="kebabCase(case_item.short_title)" :id="`case_index_full_${case_item.index}`" :data-index="case_item.index" :data-thumbnail="kebabCase(case_item.short_title)" >
              <BRow class="mb-1 justify-content-center">
                <BCol class="align-self-center offset-lg-1  offset-md-1  offset-lg-0" sm="12" cols="12" md="8" >
                  <div class="embed-text text-center pt-3">
                    <h2>{{ case_item.short_title }}</h2>
                    <img :src="getPicture(case_item.index)" :width="`150px`" />
                    <div class="text-wrapper">
                      <h3 class="intro-embed"><span>{{ case_item.intro }}</span></h3>
                    </div>
                  </div>
                  
                  <CustomSharingOptions class="justify-content-center" title="In #DeforestationInc, @ICIJOrg uncovered dozens of companies that publicly claimed to be green, but all the while were linked to allegations of environmental harm. Here are three examples."
                  :url-embed="`https://projects.icij.org/investigations/deforestation-inc/green-forestry-claims-tested/#/${kebabCase(case_item.short_title)}/embed`" 
                  :url="`https://www.icij.org/investigations/deforestation-inc/green-forestry-claims-tested/?${kebabCase(case_item.short_title)}`"></CustomSharingOptions>

                  <div class="show-more-btn text-center ">
                    <b-button target="_blank" :href="`https://www.icij.org/investigations/deforestation-inc/green-forestry-claims-tested/?${kebabCase(case_item.short_title)}`" variant="link">
                      READ MORE 
                    </b-button>
                  </div>      
                </BCol>
              </BRow>
          </div>
        </BCol>
      </BRow>
    </BContainer>
    <AppFooterEmbed>
    </AppFooterEmbed>
  </div>
  
</template>

<style lang="scss">

  .embeddable-footer {
    background-color: #1e1e1adb !important;
  }

  .embed-text {
    max-width: 640px;
    margin: 0 auto;
    h3 {
      font-size: 18px;
      color: #fff;

      span {
        background-color: #000000b3;
        color: #fff;
        line-height: 1.7em;
        padding: 1px 5px;
      }
    }

    h2 {
      font-size: 27px;
    }

    h4 {
      font-size: 16px;
      color: var(--app-color-black);
    }
  }

</style>

<script>
  import utils from '@/mixins/utils'
  import kebabCase from 'lodash/kebabCase'
  import find from 'lodash/find'
  import AppFooterEmbed from '@/components/AppFooterEmbed'
  import CustomSharingOptions from '@/components/CustomSharingOptions.vue'

  export default {
    name: 'Embed',
    mixins: [utils],
    components: {
      AppFooterEmbed,
      CustomSharingOptions
    },
    props: {
      content: {
        type: Object,
        default: null
      }
    },
    computed: {
      case_item() {
        return find(this.content.cases, item => {
          if(kebabCase(item.short_title) == this.$route.params.url_case ) {
            console.log(item)
            return item
          }        
        })
      }
    },
    methods: {
      kebabCase
    }
  }

</script>